import i18next from "i18next";

const PageWelcome = () => {

    return (
        <div className="fixed-center">
            <div className="text-center">
                <h1>{ i18next.t('welcome.title') }</h1>
                <p>{ i18next.t('welcome.description') }</p>
            </div>
        </div>
    );
}

export default PageWelcome;